// extracted by mini-css-extract-plugin
export var deleteIcon = "_tz-5";
export var deleteOption = "_tz-3";
export var divider = "_tz-2";
export var downloadIcon = "_tz-4";
export var drawer = "_tz-0";
export var drawerFooter = "_tz-6";
export var drawerOpen = "_tz-1";
export var highlighted = "_tz-7";
export var lighterHighlight = "_tz-8";